import { create } from 'zustand';
import { V1PreviewOrderCostResponse } from '@fintronners/react-api/src';

type State = {
  loading: boolean;
  error: Error | null;
  data: V1PreviewOrderCostResponse | null;
};

type Actions = {
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  setData: (data: V1PreviewOrderCostResponse | null) => void;
  reset: () => void;
};

const initialState: State = {
  loading: false,
  error: null,
  data: null,
};

export const usePreviewOrderCostStore = create<State & Actions>((set) => ({
  ...initialState,
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setData: (data) => set({ data }),
  reset: () => set(initialState),
}));
